module.exports = __webpack_public_path__ + "static/img/technology-2.68fe6fa2.png";